/* =============================================================
 * import
 * ========================================================== */
import {gsap} from "gsap/gsap-core";
import {CustomEase} from "gsap/CustomEase";

CustomEase.create("fade", "0.5, 1, 0.89, 1");
const tl = gsap.timeline();


/* =============================================================
 * functions
 * ========================================================== */
export function leave(data, duration = 1000) {
  const ms = duration / 1000;
  const filters = document.querySelectorAll('.filter_bg_item');

  gsap.to(data.current.container, {
    autoAlpha: 0,
    ease: "fade",
    duration: ms,
  });
  filters.forEach(filter => {
    gsap.set(filter, {
      autoAlpha: 0,
      scale: 1,
    });
  });

}


export function enter(data, duration = 1000) {
  const ms = duration / 1000;
  const filter = document.querySelector('#transition_home');

  gsap.fromTo(filter, {
    autoAlpha: 0,
  }, {
    autoAlpha: 1,
    ease: CustomEase.create("custom", "0.32, 0.95, 0.6, 1"),
    duration: ms,
  });

  gsap.fromTo(filter, {
    scale: 1,
  }, {
    scale: 1.1,
    ease: CustomEase.create("custom", "0.32, 0.95, 0.6, 1"),
    duration: 6,
  });

  gsap.set(data.next.container, {
    autoAlpha: 0,
  });

}


export function after(data, duration = 1000) {
  const ms = duration / 1000;
  const filter = document.querySelector('#transition_home');

  tl
    .fromTo(
      data.next.container,
      {
        autoAlpha: 0,
      }, {
        autoAlpha: 1,
        ease: CustomEase.create("custom", "0.32, 0.95, 0.6, 1"),
        duration: ms,
      },
    )
    .to(filter,
      {
        autoAlpha: 0,
        ease: CustomEase.create("custom", "0.32, 0.95, 0.6, 1"),
        duration: ms + 0.2,
      }, "-=" + ms,
    )
  ;
}

